module.exports = __webpack_public_path__ + "img/CND.5f793298.png";